import Component from 'gia/Component';
import Cookies from 'js-cookie';

export default class NewsletterModal extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      submit: {},
      thankyou: {},
      form: {},
      closeButton: {},
      interestValue:{}
    };
  }

  mount() {
    let that = this;


    // Check if cookie exists
    if (!Cookies.get('newsletter_shown')) {
      setTimeout(function() {
        // console.log($('.js--newsletter-screen'));
        that.element.classList.remove('hidden');
      }, 3000);

    }

    console.log(that.ref.form);

    this.ref.form.addEventListener('submit', function(e) {
      e.preventDefault();

      var data = new FormData();
      data.append('email', that.ref.form.email.value);
      data.append([window.csrfTokenName], window.csrfTokenValue);
      data.append('interestValue', that.ref.interestValue.value);
      console.log(data);
      that.ref.thankyou.classList.add('hidden');
      // that.ref.submit.disabled = true;
      fetch('/actions/live-yoga-teachers/newsletter/subscribe', {
        method: 'POST',
        headers: {
          // 'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: data
      })
        .then(response => response.json())
        .then(data => {
          console.log(data);
          if (data.success) {
            Cookies.set('newsletter_shown', 'true', {expires: 7});
            that.ref.thankyou.classList.remove('hidden');
            that.ref.thankyou.classList.remove('text-red-500');
            that.ref.thankyou.innerHTML = 'Thank you for subscribing!';
          } else {
            that.ref.thankyou.classList.remove('hidden');
            that.ref.thankyou.classList.add('text-red-500');
            that.ref.thankyou.innerHTML = 'We could not subscribe you at this time. You may have already subscribed or entered an invalid email address.';
          }
        })
        .catch(error => {
          // console.error('Error verifying reCAPTCHA:', error);
        });


    });

    this.ref.closeButton.addEventListener('click', function() {
      Cookies.set('newsletter_shown', 'true', {expires: 7});
      that.element.classList.add('hidden');
    });
    //
    // // Add click handler for newsletter screen
    // $('.js--newsletter-screen').on('click', function(e) {
    //   // Check if click was directly on js--newsletter-screen and not its children
    //   if (e.target === this) {
    //     $(this).hide();
    //     Cookies.set('newsletter_shown', 'true', {expires: 7});
    //   }
    // });
    //
    // $('.js--newsletter-screen__close').on('click', function() {
    //   $('.js--newsletter-screen').hide();
    //   // Set a cookie to hide newsletter popup for a week
    //   Cookies.set('newsletter_shown', 'true', {expires: 7});
    // });
    //
    // $('.newsletter-form').submit(function(e) {
    //   e.preventDefault();
    //   var $form = $(this);
    //   var data = $form.serialize();
    //   $('.newsletter-form-wrapper').height($('.newsletter-form-wrapper').height());
    //
    //   $('.newsletter-form').fadeOut(function() {
    //     $.ajax({
    //       url: '/actions/mailchimp-subscribe/audience/subscribe',
    //       type: "POST",
    //       data: data,
    //       dataType: "json",
    //       success: function(data) {
    //         if (!data.success) {
    //           // there was an error, do something with data
    //           // $form.children('.js--newsletter-error').append("<span class='newsletter-error__message'>Please enter a valid email</span>");
    //           $('.js--mailing-form__thankyou').addClass('error');
    //           $('.js--mailing-form__thankyou').html('We could not subscribe you at this time.').fadeIn();
    //
    //         } else {
    //           // Success
    //           Cookies.set('newsletter_shown', 'true', {expires: 7});
    //           $('.js--mailing-form__thankyou').removeClass('error');
    //           $('.js--mailing-form__thankyou').fadeIn();
    //           // $('.js--newsletter__message').removeClass('js--newsletter__message--error').html('Thank you for subscribing. <br/>Check your email for your confirmation link!').fadeIn();
    //           // $('.form__success', $formwrapper).html('Please check your email to complete the subscription process');
    //         }
    //       },
    //       error: function() {
    //         $('.js--mailing-form__thankyou').addClass('error');
    //         $('.js--mailing-form__thankyou').html('We could not subscribe you at this time.').fadeIn();
    //       }
    //     });
    //   })

    // })

  }

}